import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;
const voucherModeURL = `api/v1/products-app/products`;
//obtaining the paginated data
export const getVoucherMode = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${voucherModeURL}?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllVoucherMode = () => axiosInstance.get(`${voucherModeURL}?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageVoucherMode = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${voucherModeURL}?offset=${(number - 1) * rowsPerPage}&limit=${rowsPerPage}&ordering=-id`);

//creating function
export const createVoucherMode = (body) => axiosInstance.post(`${voucherModeURL}`, body);
//updating function
export const updateVoucherMode = (id, body) => axiosInstance.patch(`${voucherModeURL}/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${voucherModeURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataVoucherModeName = (e, cancelToken) =>
  axiosInstance.get(`${voucherModeURL}?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
